import React from "react";
import Checkbox from "../../../../../components/Checkbox";

export const BooleanFilters = ({
  booleanFilters,
  setBooleanFilters,
}) => {
  const walkthroughPermissionOptions = [
    "Regular Service Requests", 
    "Internal", 
    "Homeowner or Occupant", 
    "Grouped", 
    "Imported"
  ];

  return walkthroughPermissionOptions.map((permission, index) => (
    <Checkbox
      label={permission}
      size="small"
      key={`walkthrough-permission-checkbox-${index}`}
      value={booleanFilters.includes(permission)}
      onChange={() => {
        if (booleanFilters.includes(permission)) {
          setBooleanFilters(
            booleanFilters.filter((item) => item !== permission)
          );
        } else {
          setBooleanFilters([...booleanFilters, permission]);
        }
      }}
    />
  ));
};
